import { css } from 'styled-components';

export const blockContainer = css`
  position: relative;
`;
